// extracted by mini-css-extract-plugin
module.exports = {"sections":"SettingsForm_sections__38yTh"};